module.exports = "<div class=\"form-box form-response\">\r\n  <div class=\"info-item form-response\">\r\n    <div class=\"info-item-heading\">{{formFieldResponse.model.field.title}}</div>\r\n    <div class=\"\">\r\n      {{formFieldResponse.model.response.result.value | date : formFieldResponse.getDateTimeFormat()}}\r\n    </div>\r\n    <div class=\"info-item-placeholder\" ng-if=\"formFieldResponse.showPlaceholder()\">\r\n      {{::('forms.response.default.placeholder' | translate)}}\r\n    </div>\r\n  </div>\r\n</div>";


//////////////////
// WEBPACK FOOTER
// ./src/js/forms/directives/field-templates/date/response-view.html
// module id = 3436
// module chunks = 0